// removed by extract-text-webpack-plugin
module.exports = {"check":"Check__check___LwDxe","focus":"Check__focus___1qf-Z","routing":"Check__routing___K2eda","account":"Check__account___1jACk","bankTerms":"Check__bankTerms___A_mzL","bankName":"Check__bankName___3Q0cc","randomDeposit":"Check__randomDeposit___KUxvN","randomDepositHeader":"Check__randomDepositHeader___2udLr","checkContent":"Check__checkContent___2SUm7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/check/Check.less
 ** module id = 771
 ** module chunks = 0
 **/